import React from 'react';
import PageTitle from 'components/shared/PageTitle';
import RelatedUrlsPage from './RelatedUrlsPage';

const RelatedUrlsIndex = _props => {
  const props = {
    types: [
      {
        type: 'exact',
        title: t('related_urls.new_mapping.type.URL'),
      },
      {
        type: 'prefix',
        title: t('related_urls.new_mapping.type.subpages'),
      },
    ],
    param: 'url',
    path: 'related_urls',
    i18n: {
      first_column_header: t('related_urls.headers.web_url'),
      related_content_header: t('related_urls.headers.related_content'),
      groups_header: t('related_urls.headers.groups'),
      new_url: t('related_urls.new_mapping.enter_url'),
      existing_mapping_subpages: t(
        'related_urls.existing_mapping.type.subpages',
      ),
      existing_mapping_URLonly: t('related_urls.existing_mapping.type.URL'),
      lessons: t('lessons.title'),
      show_on: t('related_urls.new_mapping.show_on'),
      page_header: t('related_urls.title'),
      page_instructions: t('related_urls.learn_language.instructions'),
      link_to: t('related_urls.existing_mapping.link_to'),
      lesson_start: t('related_urls.existing_mapping.lesson_start'),
      cancel: t('common.cancel'),
      save_mapping: t('related_urls.save_mapping'),
      add_button: t('related_urls.add_url_button'),
      delete_url: t('related_urls.delete_url'),
      header_tooltip: t('related_urls.learn_language.header_tooltip'),
      header_groups_tooltip: t(
        'related_urls.learn_language.header_groups_tooltip',
      ),
      groups_placeholder: t('related_urls.learn_language.groups_placeholder'),
      no_groups_placeholder: t(
        'related_urls.learn_language.no_groups_placeholder',
      ),
      delete_tooltip: t('common.delete'),
      edit_tooltip: t('common.edit'),
      untitled_section: t('lessons.sections.default_title'),
      b_s_desc: t('related_urls.blank_slate.description'),
      b_s_title: t('related_urls.blank_slate.title'),
      b_s_call_to_action_link: t(
        'related_urls.blank_slate.call_to_action_link',
      ),
      b_s_call_to_action: t('related_urls.blank_slate.call_to_action'),
      new_learning_content: t('related_urls.new_learning_content'),
      external_link: t('related_urls.external_link'),
      everyone_group: t('related_urls.everyone_group'),
      page_content_selector: t('related_urls.page_content_selector'),
    },
  };
  return (
    <>
      <PageTitle title={t('related_urls.title')} />
      <RelatedUrlsPage {...props} />
    </>
  );
};

export default RelatedUrlsIndex;
